import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../../atoms/buttons/Button';
import TruncateTextWithButton from '../../../../../../molecules/merchant/common/buttons/TruncateTextWithButton';
import CourseDetail from './CourseDetail';

import css from './Course.module.scss';
import { MerchantBookingCourseImage } from '../../../../../../interfaces/merchants/bookings/courses';

interface Props {
  courseName: string;
  image?: MerchantBookingCourseImage;
  price?: string;
  text: string;
  duration?: number; // second
  href: string;
}

const Course: React.FC<Props> = ({
  courseName,
  image,
  price,
  text,
  duration,
  href,
}) => {
  const intl = useIntl();
  const classes = classNames(css.Course);

  return (
    <div className={classes}>
      <div className={css.Course__Header}>
        {image && image.thumb && image.thumb.url && (
          <img className={css.Course__Image} src={image.thumb.url} alt="" />
        )}
        <CourseDetail menuName={courseName} price={price} duration={duration} />
      </div>
      <div className={css.Course__Description}>
        <TruncateTextWithButton text={text} maxLine={7} />
        <Link href={href} prefetch={false} legacyBehavior>
          <Button
            className_Deprecated={css.Course__Button}
            href={href}
            isGhost={true}
          >
            {intl.formatMessage({ id: 'merchants.bookingPages.course.select' })}
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Course;
